//**********************************************************************
// # Slick.js  image slider
//**********************************************************************
$(function() {
  /* ## top page slider
  ***********************************************/
  $('.slider').slick({
    autoplay:true,
    arrows: false,
    fade: true,
    speed: 5000,
    autoplaySpeed: 3000,
  });
});
